import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import moment from 'moment'
import { useEffect, useState } from 'react'
import messagingApi from 'services/api/messaging'

import styles from './EmailViewerDialog.module.scss'

const EmailViewerDialog = ({ chatId, providerMessageId, onClose }) => {
  const [isLoading, setIsLoading] = useState(true)

  const [subject, setSubject] = useState()
  const [body, setBody] = useState()
  const [to, setTo] = useState()
  const [from, setFrom] = useState('')
  const [sentOn, setSentOn] = useState()
  const [recipientName, setRecipientName] = useState()

  const [isErred, setIsErred] = useState(false)

  useEffect(() => {
    setIsLoading(true)

    messagingApi
      .getEmail({ chatId: chatId, providerMessageId: providerMessageId })
      .then(response => {
        setSubject(response.subject)
        setBody(response.bodyInHtml)
        setTo(response.to)
        setFrom(response.from)
        setSentOn(response.sentOn)
        setRecipientName(response.recipientName)
        setIsErred(false)
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
        setIsErred(true)
      })
  }, [chatId, providerMessageId])

  if (isLoading) {
    return (
      <ConfirmationDialog>
        <div style={{ paddingBottom: 15 }}>
          <LoadingIndicator inline={true} />
        </div>
      </ConfirmationDialog>
    )
  }

  if (isErred) {
    return (
      <ConfirmationDialog onClose={onClose} title="Couldn't get email">
        <p style={{ fontSize: 15 }}>Something went wrong while showing this email</p>
      </ConfirmationDialog>
    )
  }

  return (
    <ConfirmationDialog
      title={subject}
      maxWidth={900}
      theme="blacklist"
      positiveMessage="Close"
      onClose={onClose}
      contentPadding={0}
    >
      <div className={styles.wrapper}>
        <div className={styles.emailMetaData}>
          <div className={styles.receiverAndSender}>
            <div className={styles.receiver}>
              <span className={styles.receiverName}>
                {recipientName}{' '}
                <span className={styles.recipientEmail}>
                  {'<'}
                  {to}
                  {'>'}
                </span>
              </span>
            </div>
            <div className={styles.sender}>From: {from}</div>
          </div>
          <div className={styles.emailSentOn}>
            {moment(sentOn).format('DD MMM YYYY, H:MM A')}
          </div>
        </div>
        <div dangerouslySetInnerHTML={{ __html: body }}></div>
      </div>
    </ConfirmationDialog>
  )
}

export default EmailViewerDialog
